import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { galleriesService } from 'src/services/src/service/galleries';

export const viewInspirationalImagesGalleryPageActions = {
  resetCurrentGallery: createAction('ViewInspirationalImagesGalleryPage/ResetCurrentGallery'),
  getGallery: createAsyncThunk(
    'ViewInspirationalImagesGalleryPage/GetGallery',
    async (
      { shopId, galleryId, galleryType }: Parameters<typeof galleriesService.getGallery>[0],
      { rejectWithValue }
    ) => {
      try {
        const gallery = await galleriesService.getGallery({
          shopId,
          galleryId,
          galleryType,
        });
        return gallery;
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
};
